import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor() { }

  public log(message: any) {
    const prefixLogType = "[LOG]";
    this.consoleLogger(message, prefixLogType);
  }

  public error(message: any) {
    const prefixLogType = "[ERROR]";
    this.consoleLogger(message, prefixLogType);
  }

  public info(message: any) {
    const prefixLogType = "[INFO]";
    this.consoleLogger(message, prefixLogType);
  }

  public warn(message: any) {
    const prefixLogType = "[WARN]";
    this.consoleLogger(message, prefixLogType);
  }

  private timestamp() {
    return "[" + moment().format('YYYY-MM-DD HH:mm:ss.SSS') + "]";
  }

  private consoleLogger(message: any, prefixString: string) {
    const prefixTimeStamp = this.timestamp();
    const logType = prefixString.match(/\[(.*)\]/)[1];

    switch (logType) {
      case 'LOG':
        if (typeof (message) !== "object") {
          environment.production ? (() => { })() : console.log(prefixTimeStamp + prefixString + message);
        }
        else {
          environment.production ? (() => { })() : console.log(prefixTimeStamp + prefixString);
          environment.production ? (() => { })() : console.log(message);
        }
        break;
      case "INFO":
        if (typeof (message) !== "object") {
          // tslint:disable-next-line: no-console
          environment.production ? (() => { })() : console.info(prefixTimeStamp + prefixString + message);
        }
        else {
          // tslint:disable-next-line: no-console
          environment.production ? (() => { })() : console.info(prefixTimeStamp + prefixString);
          // tslint:disable-next-line: no-console
          environment.production ? (() => { })() : console.info(message);
        }
        break;
      case "WARN":
        if (typeof (message) !== "object") {
          environment.production ? (() => { })() : console.warn(prefixTimeStamp + prefixString + message);
        }
        else {
          environment.production ? (() => { })() : console.warn(prefixTimeStamp + prefixString);
          environment.production ? (() => { })() : console.warn(message);
        }
        break;
      case "ERROR":
        if (typeof (message) !== "object") {
          environment.production ? (() => { })() : console.error(prefixTimeStamp + prefixString + message);
        }
        else {
          environment.production ? (() => { })() : console.error(prefixTimeStamp + prefixString);
          environment.production ? (() => { })() : console.error(message);
        }
        break;
    }
  }
}
